import SemanticMetrics, {
  sendMetric as _sendMetric,
  MetricTypes,
  EventSenderReporter,
  Metric,
  Tags,
} from '@spotify-internal/semantic-metrics';
import createDebug from 'debug';
import { transport } from '../transport';
import {
  WEBSITE_ORIGIN_POD_TAG,
  getWebsiteOriginPod,
} from '../website-origin-pod';

const log = createDebug('metrics:sendMetric');
let initialized = false;

class NoopReporter {
  async send() {}
}

const isDev = process.env.NODE_ENV !== 'production';

export function initialize() {
  initialized = true;

  SemanticMetrics.init({
    dev: isDev,
    key: process.env.REACT_APP_APPLICATION_KEY,
    reporter: isDev
      ? new NoopReporter()
      : EventSenderReporter.createWithCustomTransport({
          transport,
          environment: 'browser',
        }),
  });
}

function sendMetric(metric: Metric) {
  log(metric);
  if (initialized) _sendMetric(metric);
}

export function logCount(what: string, tags: Tags) {
  sendMetric({
    metric_type: MetricTypes.COUNTER,
    what,
    value: 1,
    tags: {
      [WEBSITE_ORIGIN_POD_TAG]: getWebsiteOriginPod(),
      ...tags,
    },
  });
}

export function logError(what: string) {
  logCount(what, { status: 'error' });
}

export function logSuccess(what: string) {
  logCount(what, { status: 'success' });
}

export function sendSLOCounter(featureName: string, isError: boolean) {
  if (isError) {
    logError(featureName);
  } else {
    logSuccess(featureName);
  }
}

export function logFetchConnectionState() {
  logCount('fetch_connection', { online: String(navigator.onLine) });
}
